/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface FlightBookingPaymentComponentResponse
 */
export interface FlightBookingPaymentComponentResponse {
  /**
   *
   * @type {boolean}
   * @memberof FlightBookingPaymentComponentResponse
   */
  test: boolean;
  /**
   * Supplier of this exact test quote. Travelport uses shared sandbox card collection without a Duffel component key.
   * @type {string}
   * @memberof FlightBookingPaymentComponentResponse
   */
  provider: FlightBookingPaymentComponentResponseProviderEnum;
  /**
   * Duffel-only short-lived browser component key. Absent for Travelport. Never include in booking projections, logs, or URLs.
   * @type {string}
   * @memberof FlightBookingPaymentComponentResponse
   */
  clientKey?: string;
  /**
   *
   * @type {string}
   * @memberof FlightBookingPaymentComponentResponse
   */
  quoteId: string;
  /**
   *
   * @type {string}
   * @memberof FlightBookingPaymentComponentResponse
   */
  providerOfferId: string;
  /**
   * Explicit configured sandbox vault for isolated test-card collection; never use ordinary VGS defaults.
   * @type {string}
   * @memberof FlightBookingPaymentComponentResponse
   */
  vgsSandboxVaultId?: string;
  /**
   * Temporary Duffel test Card created from the selected owned saved payment method.
   * @type {string}
   * @memberof FlightBookingPaymentComponentResponse
   */
  duffelCardId?: string;
  /**
   *
   * @type {Date}
   * @memberof FlightBookingPaymentComponentResponse
   */
  cardUnavailableAt?: Date;
}

/**
 * @export
 */
export const FlightBookingPaymentComponentResponseProviderEnum = {
  Duffel: "duffel",
  Travelport: "travelport",
} as const;
export type FlightBookingPaymentComponentResponseProviderEnum =
  (typeof FlightBookingPaymentComponentResponseProviderEnum)[keyof typeof FlightBookingPaymentComponentResponseProviderEnum];

/**
 * Check if a given object implements the FlightBookingPaymentComponentResponse interface.
 */
export function instanceOfFlightBookingPaymentComponentResponse(
  value: object
): value is FlightBookingPaymentComponentResponse {
  if (!("test" in value) || value["test"] === undefined) return false;
  if (!("provider" in value) || value["provider"] === undefined) return false;
  if (!("quoteId" in value) || value["quoteId"] === undefined) return false;
  if (!("providerOfferId" in value) || value["providerOfferId"] === undefined)
    return false;
  return true;
}

export function FlightBookingPaymentComponentResponseFromJSON(
  json: any
): FlightBookingPaymentComponentResponse {
  return FlightBookingPaymentComponentResponseFromJSONTyped(json, false);
}

export function FlightBookingPaymentComponentResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FlightBookingPaymentComponentResponse {
  if (json == null) {
    return json;
  }
  return {
    test: json["test"],
    provider: json["provider"],
    clientKey: json["client_key"] == null ? undefined : json["client_key"],
    quoteId: json["quote_id"],
    providerOfferId: json["provider_offer_id"],
    vgsSandboxVaultId:
      json["vgs_sandbox_vault_id"] == null
        ? undefined
        : json["vgs_sandbox_vault_id"],
    duffelCardId:
      json["duffel_card_id"] == null ? undefined : json["duffel_card_id"],
    cardUnavailableAt:
      json["card_unavailable_at"] == null
        ? undefined
        : new Date(json["card_unavailable_at"]),
  };
}

export function FlightBookingPaymentComponentResponseToJSON(
  json: any
): FlightBookingPaymentComponentResponse {
  return FlightBookingPaymentComponentResponseToJSONTyped(json, false);
}

export function FlightBookingPaymentComponentResponseToJSONTyped(
  value?: FlightBookingPaymentComponentResponse | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    test: value["test"],
    provider: value["provider"],
    client_key: value["clientKey"],
    quote_id: value["quoteId"],
    provider_offer_id: value["providerOfferId"],
    vgs_sandbox_vault_id: value["vgsSandboxVaultId"],
    duffel_card_id: value["duffelCardId"],
    card_unavailable_at:
      value["cardUnavailableAt"] == null
        ? value["cardUnavailableAt"]
        : value["cardUnavailableAt"].toISOString(),
  };
}
